import {
  isEmpty as _isEmpty, isNil as _isNil, isObjectLike as _isObjectLike, isString as _isString
} from 'lodash-es';

import { isNullOrWhitespace } from './is-null-or-whitespace';

export function isNilOrEmpty(obj: any) {
  return _isNil(obj) || ( _isObjectLike(obj) || _isString(obj)) && _isEmpty(obj) || (_isString(obj) && isNullOrWhitespace(obj));
}
